import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sensitivity',
  templateUrl: './sensitivity.component.html',
  styleUrls: ['./sensitivity.component.scss']
})
export class SensitivityComponent implements OnInit {
  constructor() {
  }

  ngOnInit() {
  }
}
